/**
 * Mailchimp Newsletter Form - JSONP submission
 * Avoids CORS issues by using Mailchimp's post-json endpoint with JSONP callback.
 */
(function () {
  document.querySelectorAll('.mailchimp-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var statusEl = form.querySelector('.mailchimp-form__status');
      var submitBtn = form.querySelector('.mailchimp-form__submit-btn');
      var actionUrl = form.getAttribute('data-action-url');

      
      if (!actionUrl) {
        showStatus(statusEl, 'error', message(form, 'msgNotConfigured', 'The newsletter is currently unavailable.'));
        return;
      }

      // Check honeypot - if filled, silently "succeed" (it's a bot)
      var honeypot = form.querySelector('.mailchimp-form__hp input');
      if (honeypot && honeypot.value) {
        showStatus(
          statusEl,
          'success',
          form.getAttribute('data-success-message') || 'Thank you!'
        );
        return;
      }

      // Collect form data
      var email = form.querySelector('input[name="EMAIL"]');
      var fname = form.querySelector('input[name="FNAME"]');
      var lname = form.querySelector('input[name="LNAME"]');

      if (!email || !email.value) {
        showStatus(statusEl, 'error', message(form, 'msgEmailRequired', 'Please enter your email address.'));
        return;
      }

      // Disable button during submission
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add('btn--loading');
      }

      // Build JSONP URL - replace /post? with /post-json? and add callback
      var jsonpUrl = actionUrl.replace('/post?', '/post-json?');
      var params = '&EMAIL=' + encodeURIComponent(email.value);
      if (fname && fname.value) {
        params += '&FNAME=' + encodeURIComponent(fname.value);
      }
      if (lname && lname.value) {
        params += '&LNAME=' + encodeURIComponent(lname.value);
      }

      // Add Mailchimp tag if configured
      var tag = form.getAttribute('data-tag');
      if (tag) {
        params += '&tags=' + encodeURIComponent(tag);
      }

      // Create unique callback name
      var callbackName = 'mailchimp_callback_' + Date.now();

      // JSONP callback
      window[callbackName] = function (response) {
        // Clean up
        delete window[callbackName];
        var script = document.getElementById(callbackName);
        if (script) script.remove();

        // Re-enable button
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('btn--loading');
        }

        if (response.result === 'success') {
          showStatus(
            statusEl,
            'success',
            form.getAttribute('data-success-message') || response.msg
          );
          form.reset();
        } else {
          // Clean up Mailchimp error messages (remove HTML, simplify)
          var msg = response.msg || message(form, 'msgError', 'An error occurred. Please try again.');
          // Remove "0 -" prefix that Mailchimp adds
          msg = msg.replace(/^0 - /, '');
          showStatus(statusEl, 'error', msg);
        }
      };

      // Create and inject JSONP script tag
      var script = document.createElement('script');
      script.id = callbackName;
      script.src = jsonpUrl + params + '&c=' + callbackName;

      // Handle network errors
      script.onerror = function () {
        delete window[callbackName];
        script.remove();
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('btn--loading');
        }
        showStatus(
          statusEl,
          'error',
          message(form, 'msgConnection', 'Connection error. Please try again.')
        );
      };

      document.body.appendChild(script);
    });
  });

  // Translated messages are rendered by Liquid into data-msg-* attributes on the form
  function message(form, key, fallback) {
    return form.dataset[key] || fallback;
  }

  function showStatus(el, type, message) {
    if (!el) return;
    el.className = 'mailchimp-form__status mailchimp-form__status--visible mailchimp-form__status--' + type;
    el.textContent = '';

    // Parse message safely - Mailchimp may return HTML
    var temp = document.createElement('div');
    temp.innerHTML = message;
    el.textContent = temp.textContent || temp.innerText || message;
  }
})();
